import { useSelector } from 'react-redux';

import { Logo } from '@habitech/keychain-atoms-display';
import { getEmail } from '@domains/user/store/slices/user-slice/user-slice';
import { RootState } from '@store';
import { InternalModule } from '../launch.constants';
import { ExternalTool } from '../../../config/external-tools';
import { NavBar, NavBrand, NavDivider, NavCenter, NavTitle, NavActions, NavEmail, LogoutButton } from '../styles';
import { SearchBar } from './SearchBar';
import { FlagDropdown } from './FlagDropdown';

interface LaunchNavBarProps {
  visibleModules: InternalModule[];
  onOpenModule:   (path: string) => void;
  onOpenTool:     (tool: ExternalTool) => void;
  onLogout:       () => void;
}

export const LaunchNavBar = ({ visibleModules, onOpenModule, onOpenTool, onLogout }: LaunchNavBarProps) => {
  const email   = useSelector(getEmail);
  const country = useSelector((s: RootState) => s.domainUserAuth.country);

  return (
    <NavBar>
      <NavBrand>
        <div style={{ zoom: 0.65, lineHeight: 0, flexShrink: 0 }}>
          <Logo size="small" type={country !== 'CO' ? 'tuhabi' : 'habi'} variant="negative" />
        </div>
        <NavDivider />
        <NavTitle>Portal IdM</NavTitle>
      </NavBrand>

      <NavCenter>
        <SearchBar
          visibleModules={visibleModules}
          onOpenModule={onOpenModule}
          onOpenTool={onOpenTool}
        />
      </NavCenter>

      <NavActions>
        {email && <NavEmail>{email}</NavEmail>}
        <FlagDropdown />
        <LogoutButton onClick={onLogout}>Cerrar sesión</LogoutButton>
      </NavActions>
    </NavBar>
  );
};
